import {PayloadAction} from "@reduxjs/toolkit";
import {OrderModel} from "../../pages/shared/models/order/order-item.model";
import {Product} from "../../pages/shared/models/order/product.model";
import {CountryModel} from "../../pages/shared/models/countryModel";
import {Recipient} from "../../pages/shared/models/user/recipient/recipient";
import {CurrencyModel, WeightUnitModel} from "./static-data.reducers";
import {ConditionEnum} from "../../pages/orders/enums/order/condition.enum";
import {TypeEnum} from "../../pages/orders/enums/order/type.enum";
import {NewOrderSlice} from "../slices/new-order-slice";
import {WarehouseModel} from "../../pages/shared/models/order/warehouse.model";
import {ShippingMethodModel} from "../../pages/shared/models/order/ShippingMethod.model";
import {ResponseStatus} from "../../actions/types";
import {POLAND_COUNTRY_ID} from "../../constants";

export function changeOrderWarehouse (state: NewOrderSlice, action: PayloadAction<{ warehouse: WarehouseModel, country: CountryModel, currencies: CurrencyModel[]}>) {
    const order = {...state.newOrder} as OrderModel;

    order.shippingInfo = {...order.shippingInfo, country: action.payload.country, warehouse: action.payload.warehouse};

    if (!order.products[0].price) {
            order.products[0].currency = action.payload.country.countryId === POLAND_COUNTRY_ID
                ? action.payload.currencies[3]
                : action.payload.currencies[2]
    }

    state.newOrder = order;
}

export function changeOrderShippingMethod (state: NewOrderSlice, action: PayloadAction<ShippingMethodModel>) {
    const order = {...state.newOrder} as OrderModel;

    order.shippingInfo = {...order.shippingInfo, shippingMethod: action.payload};

    state.newOrder = order;
}

// TODO: consider having a single function to handle simple changes

export function changeOrderRecipient (state: NewOrderSlice, action: PayloadAction<Recipient>) {
    const order = {...state.newOrder};
    order.recipient = action.payload;

    state.newOrder = order as OrderModel;
}

export function changeOrderName (state: NewOrderSlice, action: PayloadAction<string>) {
    if (state.newOrder) {
        state.newOrder.name = action.payload;
    }
}

export function changeOrderAddress2 (state: NewOrderSlice, action: PayloadAction<string>) {
    const order = {...state.newOrder};
    order.address2 = action.payload;

    state.newOrder = order as OrderModel;
}

export function changeOrderProducts (state: NewOrderSlice, action: PayloadAction<Product[]>) {
    const order = {...state.newOrder};
    order.products = action.payload;

    state.newOrder = order as OrderModel;
}

export function changeOrderMultipleValues (state: NewOrderSlice, action: PayloadAction<{[key: string]: any}>) {
    const order = {...state.newOrder, ...action.payload};

    state.newOrder = order as OrderModel;
}

export function onCreateEmptyOrder (state: NewOrderSlice, action: PayloadAction<{currency: CurrencyModel, weightUnit: WeightUnitModel, products: Product[], recipient: Recipient, country: CountryModel, destinationWarehouse?: WarehouseModel, orderId?: number}>) {
    const newOrderData = action.payload;
    
    const emptyProduct = {
        trackingNumber: '',
        otp: '',
        name: '',
        description: '',
        price: 0,
        currency: newOrderData.currency,
        weight: 0,
        weightUnit: newOrderData.weightUnit,
        storeName: '',
        condition: ConditionEnum.NEW,
        invoice: [] as File[],
        image: [] as File[]
    } as Product;

    state.newOrder = {
        type: TypeEnum.IMPORT,
        internalTrackingNumber: '',
        name: '',
        recipient: newOrderData.recipient,
        trackRecord: [],
        enteredDate: null,
        expectedDate: null,
        shippingInfo: {
            country: newOrderData.country,
            warehouse: newOrderData.country.warehouse[0], // TODO: change to default warehouse
            destinationWarehouse: newOrderData.destinationWarehouse,
            shippingMethod: {shippingMethodId: 1} as ShippingMethodModel,
        },
        paymentStatus: null,
        paymentInfo: null,
        products: newOrderData.products.length ? newOrderData.products : [emptyProduct],
        weight:  0,
        weightUnit: {weightUnitId: 1, name: 'kg'},
        additionalService: []
    } as OrderModel
}

export function onCreateOrderPending (status: ResponseStatus, payload: any, state: NewOrderSlice) {
    state.isLoading = true;
}
export function onCreateOrderFulfilled (status: ResponseStatus, payload: any, state: NewOrderSlice) {
    state.isLoading = false;
}
export function onCreateOrderRejected (status: ResponseStatus, payload: any, state: NewOrderSlice) {
    state.errors = payload?.errors;
    state.isLoading = false;
}
export function onCreateUnannouncedOrderFulfilled (status: ResponseStatus, payload: any, state: NewOrderSlice) {
    state.isLoading = false;
}
